import { capitalize } from '../../utils/filter'
import i18n from '../../libs/i18n'

export default {
  availableFilters: [
    {
      field: 'createdAt',
      i18n: capitalize(i18n.t('createdAt')),
      subFields: [],
      type: 'date',
    },
    {
      field: 'createdBy',
      i18n: capitalize(i18n.t('createdBy')),
      subFields: [],
      type: 'employee',
    },
    {
      field: 'title',
      i18n: capitalize(i18n.t('title')),
      subFields: [],
      type: 'text',
    },
    {
      field: 'startDate',
      i18n: capitalize(i18n.t('startDate')),
      subFields: [],
      type: 'date',
    },
    {
      field: 'endDate',
      i18n: capitalize(i18n.t('endDate')),
      subFields: [],
      type: 'date',
    },
    {
      field: 'type',
      i18n: capitalize(i18n.t('type')),
      subFields: [],
      type: 'text',
    },
    {
      field: 'isValidated',
      i18n: capitalize(i18n.t('isValidated')),
      subFields: [],
      type: 'boolean',
    },
  ].sort((a, b) => a.i18n < b.i18n ? -1 : 1),
  availableListColumns: [
    // {
    //   title: capitalize(i18n.t('title')),
    //   translateTitle: false,
    //   key: 'title',
    //   sortable: true,
    //   cell: {
    //     center: false,
    //     useDisplay: false,
    //     isDate: false,
    //     isDateTime: false,
    //     translate: false,
    //     isCurrency: false
    //   }
    // },
    {
      title: capitalize(i18n.tc('employee')),
      translateTitle: true,
      key: '_employee',
      sortable: true,
      cell: {
        center: false,
        useDisplay: false,
        isDate: false,
        isDateTime: false,
        translate: false,
        isCurrency: false
      }
    },
    // {
    //   title: capitalize(i18n.t('status')),
    //   translateTitle: true,
    //   key: 'status_name',
    //   sortable: true,
    //   cell: {
    //     center: false,
    //     useDisplay: false,
    //     isDate: false,
    //     isDateTime: false,
    //     translate: false,
    //     isCurrency: false
    //   }
    // },
  ],
  events: [],
  emptyEvent: {},
  isKanbanWorkFloList: false,
  fieldFilters: [
    // {
    //   name: 'title',
    //   type: 'text',
    //   filter: {}
    // },
    {
      name: 'startDate',
      type: 'date',
      filter: {}
    },
    {
      name: 'endDate',
      type: 'date',
      filter: {}
    },
    {
      name: 'type',
      type: 'list',
      data: ['holiday'],
      isDisabled: true,
      filter: {}
    },
    // {
    //   name: 'status',
    //   type: 'list',
    //   data: ['Prospect', 'Lead', '...'],
    //   entity: 'status_name',
    //   filter: {}
    // },
    {
      name: 'createdBy',
      type: 'employee',
      multiple: false,
      filter: {}
    },
  ],
  params: {
    entity: [],
    collection: []
  },
  eventsContext: {
    page: 1,
    filters: []
  }
}